import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class ComparatorAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normTres = 1.6;
		this.normVccMin = 0.95;
		this.normVccMax = 6;
		this.normVio = 1;
		this.normIcc = 1.7;

		this.rankTres = 0;
		this.rankVccMin = 0;
		this.rankVccMax = 0;
		this.rankVio = 0;
		this.rankIcc = 0;

		this.weightTres = 0.2;
		this.weightVccMin = 0.05;
		this.weightVccMax = 0.05;
		this.weightVio = 0.15;
		this.weightIcc = 0.05;

		this.rTres = 0;
		this.rVccMin = 0;
		this.rVccMax = 0;
		this.rVio = 0;
		this.rIcc = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_Tres,rTres,rankTres,' +
					'part_VccMin,rVccMin,rankVccMin,' +
					'part_VccMax,rVccMax,rankVccMax,' +
					'part_Vio,rVio,rankVio,' +
					'part_Icc,rIcc,rankIcc,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Response Time  tres Typ (ns)---------------------------------------------

		[this.rankTres, this.rTres] = this.calculateRankSingleSliderLTE(CIDS.T_RES_TYP, product, this.normTres);

		// ---------------------------------------------Supply voltage  VCC Min (V)---------------------------------------------

		[this.rankVccMin, this.rVccMin] = this.calculateRankSingleSliderLTE(CIDS.V_CC_MIN, product, this.normVccMin);

		// ---------------------------------------------Supply voltage  VCC Max (V)---------------------------------------------

		[this.rankVccMax, this.rVccMax] = this.calculateRankSingleSliderGTE(CIDS.V_CC_MAX, product, this.normVccMax);

		// ---------------------------------------------Input Offset Voltage  VIO Max (mV)---------------------------------------------

		[this.rankVio, this.rVio] = this.calculateRankSingleSliderLTE(CIDS.V_IO_MAX, product, this.normVio);

		// ---------------------------------------------Supply Current  ICC Typ (mA)---------------------------------------------

		[this.rankIcc, this.rIcc] = this.calculateRankSingleSliderLTE(CIDS.I_CC_TYP, product, this.normIcc);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightTres * this.rankTres +
			this.weightVccMin * this.rankVccMin +
			this.weightVccMax * this.rankVccMax +
			this.weightVio * this.rankVio +
			this.weightIcc * this.rankIcc;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightTres - this.weightVccMin - this.weightVccMax - this.weightVio - this.weightIcc) *
				super.execute(product) +
			feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
